import React, { useEffect, useState } from "react";
import { AppstoreOutlined } from "@ant-design/icons";
import { Menu } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { FaRegHandshake } from "react-icons/fa6";
import { LiaUniversitySolid } from "react-icons/lia";
import {
  MdAppRegistration,
} from "react-icons/md";
import { MdOutlinePendingActions } from "react-icons/md";
import { LuFilePlus2 } from "react-icons/lu";
import { useDispatch } from "react-redux";
import { TbFileSettings } from "react-icons/tb";
import { useLocation } from "react-router-dom";

const DashboardMenu = ({ menubar_Status, onClose }) => {
  const navigate = useNavigate();
  const [stateOpenKeys, setStateOpenKeys] = useState([]);

  const items = [
    {
      key: "1",
      icon: <AppstoreOutlined />,
      label: "Dashboard",
      routes: "/admin",
    },
    {
      key: "5",
      label: "Add-Edit",
      icon: <FaRegHandshake />,
      children: [
        {
          key: "6",
          label: "Category",
          icon: <LiaUniversitySolid />,
          children: [
            {
              key: "7",
              label: "Add category",
              routes: "/admin/add-category",
              icon: <MdOutlinePendingActions />,
            },
            {
              key: "9",
              label: "Search category",
              routes: "/admin/list-category",
              icon: <MdOutlinePendingActions />,
            },
          ],
        },
      ],
    },
    {
      key: "13",
      label: "Reporters Management",
      icon: <TbFileSettings />,
      children: [
        {
          key: "141",
          label: "Add-Reporters",
          routes: "/admin/add-reporter",
          icon: <LuFilePlus2 />,
        },
        {
          key: "1521",
          label: "All Reporter",
          routes: "/admin/all-list-reporter",
          icon: <MdOutlinePendingActions />,
        },
        {
          key: "152",
          label: "Approved Reporters",
          routes: "/admin/approved-list-reporter",
          icon: <MdOutlinePendingActions />,
        },
        {
          key: "1511",
          label: "Pending Reporters",
          routes: "/admin/not-approved-list-reporter",
          icon: <MdOutlinePendingActions />,
        },
        {
          key: "1512",
          label: "Blocked Reporters",
          routes: "/admin/blocked-list-reporter",
          icon: <MdOutlinePendingActions />,
        },
      ],
    },

    {
      key: "24",
      label: "News Management",
      icon: <FaRegHandshake />,
      children: [
        {
          key: "25",
          label: "Add News",
          routes: "/admin/add-news",
          icon: <MdAppRegistration />,
        },
        {
          key: "26",
          label: "Published News",
          routes: "/admin/list-news",
          icon: <MdOutlinePendingActions />,
        },
        {
          key: "261",
          label: "Unpublished News",
          routes: "/admin/unpublished-news",
          icon: <MdOutlinePendingActions />,
        },
        {
          key: "263",
          label: "Cancelled News",
          routes: "/admin/cancelled-news",
          icon: <MdOutlinePendingActions />,
        },
      ],
    },
    {
      key: "27",
      label: "Add Mandal",
      icon: <FaRegHandshake />,
      children: [
        {
          key: "28",
          label: "Add-Mandal",
          routes: "/admin/add-mandal",
          icon: <MdAppRegistration />,
        },
        {
          key: "29",
          label: "Mandal-List",
          routes: "/admin/list-mandal",
          icon: <MdOutlinePendingActions />,
        },
      ],
    },
    {
      key: "30",
      label: "Media Management",
      icon: <FaRegHandshake />,
      children: [
        {
          key: "31",
          label: "Birthday Images",
          routes: "/admin/birthday-images",
          icon: <MdAppRegistration />,
        },
        {
          key: "32",
          label: "Viral Images",
          routes: "/admin/viral-images",
          icon: <MdOutlinePendingActions />,
        },
      ],
    },
  ];

  const getLevelKeys = (items1) => {
    const key = {};
    const func = (items2, level = 1) => {
      items2.forEach((item) => {
        if (item.key) {
          key[item.key] = level;
        }
        if (item.children) {
          func(item.children, level + 1);
        }
      });
    };
    func(items1);
    return key;
  };
  const levelKeys = getLevelKeys(items);

  const onOpenChange = (openKeys) => {
    const currentOpenKey = openKeys.find(
      (key) => stateOpenKeys.indexOf(key) === -1
    );
    // open
    if (currentOpenKey !== undefined) {
      const repeatIndex = openKeys
        .filter((key) => key !== currentOpenKey)
        .findIndex((key) => levelKeys[key] === levelKeys[currentOpenKey]);
      setStateOpenKeys(
        openKeys
          // remove repeat key
          .filter((_, index) => index !== repeatIndex)
          // remove current level all child
          .filter((key) => levelKeys[key] <= levelKeys[currentOpenKey])
      );
    } else {
      // close
      setStateOpenKeys(openKeys);
    }
  };

  const navigationclick = (value) => {
    const nav_link = value.item.props.routes;
    navigate(`${nav_link}`);
    onClose();
  };

  return (
    <>
      <div className="menu_main_container">
        <Menu
          mode="inline"
          expandIcon={menubar_Status === true ? null : ""}
          defaultSelectedKeys={["231"]}
          openKeys={stateOpenKeys}
          onOpenChange={onOpenChange}
          onClick={(e) => navigationclick(e)}
          items={items}
          inlineCollapsed={menubar_Status}
          style={{
            background: "#00324D",
          }}
        />
      </div>
    </>
  );
};

export default DashboardMenu;
